/* istanbul ignore file */
import React from "react";

export default React.createContext({
    disabled: false,
    setDisabled: () => {},
    setState: () => {}
});